import React from "react";
import $ from 'jquery';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { CLICKED, CMSPath, REACT_APP_NEWER_DESIGN, WITH_MASTER_CONNECTOR } from "../../../config/constant";
import { currentWidget, setRegPage, setShowCustomPopup } from "../../../action/action";
import { locationSelectorWidget, myTripsKeys, theKnowKeys } from "../../../config/layout2constant";
import { setAdminLoginPage, setCurrentHomePage, setCurrentHomePageBeforeNotificationTab, setLoginRequired, setOpenExternalLinkInSameTab, showConfirmationPage } from "../../action/homeAction";
import { inAppBrowser } from "../../JS/inAppBrowser";
import { guestJourneyNotification, sendAnalytics } from "../../../action/homeAction";
import { setCurrentTabNavItemList } from "../../action/action";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { buttonColor } from "../../../JS/setColors";


const CustomAfterLoaderScreen2 = (props) => {

    const { t } = props;
    let room = localStorage.getItem("room");

    const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
    const master_hotel_code = process.env.REACT_APP_CLIENT_CONFIG.replace("GJ_", "").toUpperCase();
    const handleRedirectButtonClick = (btnAction) => {        

        if(btnAction && btnAction.params && btnAction.params.appPath==="#CLOSE_PRELOADER"){
           
            props.closeCustomScreenAfterLoader(true)
            return;
        }

        if(btnAction && btnAction.params && (btnAction.params.appPath == "login" || btnAction.params.appPath == "/login")){
            props.setRegPage(true)
            return;
        } 
        
        if(btnAction && btnAction.params && btnAction.params.appPath == "/selectHotel"){
            const isLocationTabThere = props.footerTabList.findIndex(tabList => locationSelectorWidget.some(el => el === tabList.uniqueKey.toLowerCase()));

            if(isLocationTabThere != -1){
                props.setCurrentHomePage(props.footerTabList[isLocationTabThere]);
                props.closeCustomScreenAfterLoader(true)
                return;
            }

        }

        if(btnAction && btnAction.params && btnAction.params.appPath == "/theKnowTrips"){
             let myTripsTab = props.footerTabList && props.footerTabList.find((item) => {
                        return myTripsKeys.includes(item.uniqueKey.toLowerCase())
                    });
            
                    if (myTripsTab) {
                        props.setCurrentHomePage(myTripsTab);
            
                        console.log("this.props.footerTabList", myTripsTab)
                        props.widgetList.map((item) => {
                            if (item.uniqueKey === myTripsTab.uniqueKey || item.uniqueKey === myTripsTab.tabName.replace(/ /g, '').toLowerCase()) {
                                props.setCurrentTabNavItemList();
                                props.setCurrentTabNavItemList(item.widgets);
                            }
                        })
                        props.currentWidget({});
                    }

        }

        if( btnAction &&  btnAction.params){     
            props.handleRedirect(btnAction)
        }
    }

    const sendWelcomeAnalytics = (buttonIndex, buttonLabel) => {
            const eventName = `WELCOME_SCREEN_BUTTON_${buttonIndex}`;

            const localKey = `${eventName}_EVENT_SENT`;
            const alreadySent = sessionStorage.getItem(localKey);

            if (!alreadySent) {
                const label = getDefaultAnalyticsLabel({
                    appVersion: props.installedAppVersion
                        ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
                        : ""
                });
                props.sendAnalytics(
                    null,
                    eventName,
                    CLICKED,
                    {
                        ...label,
                        pageName: "WELCOME SCREEN",
                        widgetSessionId: localStorage.getItem("checkinSessionToken"),
                        buttonLabel : String(buttonLabel).replace(" <br/>","")
                    },
                    0,
                    false,
                    () => sessionStorage.setItem(localKey, true)
                );
            }
        };
    
    const closeCustomScreenAfterLoaderClicked = (buttonLabel)=>{

        props.closeCustomScreenAfterLoader(true); 

        let lastButtonIndex=2;

        if( props.screenInfoAfterLoader.btnAction && (!room || room == "null") &&  Array.isArray(props.screenInfoAfterLoader.btnAction)){
            lastButtonIndex = props.screenInfoAfterLoader.btnAction.length() + 1;
        } 

        sendWelcomeAnalytics(lastButtonIndex, buttonLabel);
    }
    
    React.useEffect(() => {
        $("body").addClass("overlay-cast");
    },[])

    React.useEffect(() => {
        if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(true);

        return () => {
            if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(false);
        }
    },[])


    return (
<>
        { process.env.REACT_APP_NEWER_DESIGN=="true" && <header className="welcomeheader inner-pages w-footer subpages splash-header">
        
            <div className="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
      </header>
        }
        <section id="landingPage" class="landing splash-screen">
            {props.screenInfoAfterLoader.backgroundVideo && props.screenInfoAfterLoader.backgroundVideo.videoURI ?
                <div class="splash-video">
                    <video playsInline loop="true" preload="true" autoplay="true" muted={props.screenInfoAfterLoader.backgroundVideo.enableSound ? "false" : "true"} poster={process.env.REACT_APP_WELCOME_VIDEO_FROM_ASSETS == 'true' ? "welcome_video/welcome_poster_image.png" : `${CMSPath}${props.screenInfoAfterLoader.backgroundVideo.posterURI}`} height="100%" width="100%">
                        <source src={process.env.REACT_APP_WELCOME_VIDEO_FROM_ASSETS == 'true' ? "welcome_video/welcome_video.mp4" : `${CMSPath}${props.screenInfoAfterLoader.backgroundVideo.videoURI}`} type="video/mp4" />
                    </video>
                </div>
            : props.screenInfoAfterLoader.imageURI &&
                <div class="splash-img">
                    <img src={`${CMSPath}${props.screenInfoAfterLoader.imageURI}`} />
                </div>
            }

                { props.screenInfoAfterLoader.heading && <div class="splash-text">
                    <div dangerouslySetInnerHTML={{__html:props.screenInfoAfterLoader.heading.headingText}} class='heading'></div>
                    {props.screenInfoAfterLoader.heading.subheadingText && <div dangerouslySetInnerHTML={{__html:props.screenInfoAfterLoader.heading.subheadingText}} class='subheading' ></div>}
                </div>
                }

            <div class="splash-ctrl">
            {!REACT_APP_NEWER_DESIGN && <div class="splash-brand">
                    <img src={`${CMSPath}${props.screenInfoAfterLoader.hotelLogo ? props.screenInfoAfterLoader.hotelLogo : props.logo}`} />
                </div>}

                {props.screenInfoAfterLoader.btnAction && (!room || room == "null") && 
                    (Array.isArray(props.screenInfoAfterLoader.btnAction)
                    ?<>{  props.screenInfoAfterLoader.btnAction.map((btnAction,index)=>{return <a onClick={()=>{handleRedirectButtonClick(btnAction); sendWelcomeAnalytics(index+1, btnAction.btnText);}} class={`button primary w-100 margin-bottom-1 ${btnAction.btnClass}`} dangerouslySetInnerHTML={{__html:btnAction.btnText }}></a>})}</>
                    :<>{  <a onClick={()=>{handleRedirectButtonClick(props.screenInfoAfterLoader.btnAction); sendWelcomeAnalytics(1, props.screenInfoAfterLoader.btnAction.btnText || t(`screenAfterLoader.primaryBtnText`)); } } class="button primary w-100 margin-bottom-1">{props.screenInfoAfterLoader.btnAction.btnText || t(`screenAfterLoader.primaryBtnText`)}</a>}</>
                     )
                }
                
                <a class="button secondary w-100 margin-bottom-1 close-screen" onClick={() => {  closeCustomScreenAfterLoaderClicked(t(`screenAfterLoader.welcome`)); }} >{t(`screenAfterLoader.welcome`)}</a>
                { (!room || room == "null") && ( WITH_MASTER_CONNECTOR ? (current_hotel_code!=master_hotel_code) : true ) && <div class="subtext" onClick={() => props.setRegPage(true)}>{t(`screenAfterLoader.subText1`)} <a>{t(`screenAfterLoader.subText2`)}</a></div>}
            </div>
            <div class="splash-disc">
            <span style={{display:"none"}}>{t(`screenAfterLoader.subText4`)} {new Date().getFullYear()}</span>
                {t(`screenAfterLoader.subText3`)}
                </div>
        </section>

</>
    )
}

const mapStateToProps = state => {
    return {
        screenInfoAfterLoader: state.store.home.screenInfoAfterLoader,
        footerTabList: state.store.home.currentDuration && state.store.home.currentDuration.tabDetails.length > 0 ? state.store.home.currentDuration.tabDetails : [],
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
            externalSignIn: state.store2.externalSignIn,
        currentHomePage: state.store2.currentHomePage,
        menuColor: state.store.home.MenuColor,
        widgetList: state.store2.sideNavBar.widgetList,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}

export default connect(mapStateToProps, { setRegPage, setCurrentHomePage,
    setAdminLoginPage,
    showConfirmationPage,
    setOpenExternalLinkInSameTab,
    sendAnalytics,
    setLoginRequired,
    currentWidget,
    setCurrentHomePageBeforeNotificationTab,
    guestJourneyNotification,
    setShowCustomPopup,
    setCurrentTabNavItemList })(withTranslation('translations')(CustomAfterLoaderScreen2));





    // {
    //     "backgroundVideo": {
    //         "posterURI": "/../cmsData/hoteligenceClient/mobileApp/welcomePosterImage.png",
    //         "videoURI": "/../cmsData/hoteligenceClient/mobileApp/welcomeVideo.mp4"
    //     },
    //     "btnAction": [
    //         {
    //             "btnText": "Sign in to the know",
    //             "params": {
    //                 "appPath": "/theKnow"
    //             },
    //             "btnClass":"the-know-profile"
    //         },
    //         {
    //             "btnText": "DISCOVER OUR HOTELS AND THE KNOW",
    //             "params": {
    //                 "appPath": "#CLOSE_PRELOADER"
    //             },
    //              "btnClass":"location"
    //         },
    //         {
    //             "btnText": "FIND MY STAY",
    //             "params": {
    //                 "appPath": "/theKnowTrips"
    //             },
    //              "btnClass":"the-know-trips"
    //         }
    //     ],
    //     "heading": {
    //         "headingText": "WELCOME TO <br/> VIRGIN HOTELS",
    //         "subheadingText": "Where To Next?"
    //     },
    //     "imageURI": "example.jpeg",
    //     "screenType": "default",
    //     "showAfterLogin": false,
    //     "showAfterScreen": true,
    //     "showOnlyAtFirstLaunch": false
    // }